/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * last_week object
 * @export
 * @interface GetFwLeaderboardsCharactersLastWeekLastWeek
 */
export interface GetFwLeaderboardsCharactersLastWeekLastWeek {
    /**
     * Amount of kills
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersLastWeekLastWeek
     */
    amount?: number;
    /**
     * character_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersLastWeekLastWeek
     */
    characterId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCharactersLastWeekLastWeek interface.
 */
export function instanceOfGetFwLeaderboardsCharactersLastWeekLastWeek(value: object): value is GetFwLeaderboardsCharactersLastWeekLastWeek {
    return true;
}

export function GetFwLeaderboardsCharactersLastWeekLastWeekFromJSON(json: any): GetFwLeaderboardsCharactersLastWeekLastWeek {
    return GetFwLeaderboardsCharactersLastWeekLastWeekFromJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersLastWeekLastWeekFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCharactersLastWeekLastWeek {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'characterId': json['character_id'] == null ? undefined : json['character_id'],
    };
}

export function GetFwLeaderboardsCharactersLastWeekLastWeekToJSON(json: any): GetFwLeaderboardsCharactersLastWeekLastWeek {
    return GetFwLeaderboardsCharactersLastWeekLastWeekToJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersLastWeekLastWeekToJSONTyped(value?: GetFwLeaderboardsCharactersLastWeekLastWeek | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'character_id': value['characterId'],
    };
}

